import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { userAPI } from 'API/user-api';
import { DEFAULT_QUERY_STALE_TIME } from 'queries/constant';
import { UsersInAccountResponse } from 'API/user-api/types';

export const useUsersInAccountQuery = (
    props: Partial<Omit<UseQueryOptions<UsersInAccountResponse>, 'queryFn'>> = {},
) => {
    return useQuery({
        queryKey: ['usersInAccount'],
        queryFn: async () => userAPI.getUsersInAccount(),
        staleTime: DEFAULT_QUERY_STALE_TIME,
        ...props,
    });
};
